import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import EngineerLayout from './EngineerLayout';
import { db } from '../../firebase';
import { ref as dbRef, onValue } from 'firebase/database';
import { 
  FaArrowLeft,
  FaPlus
} from 'react-icons/fa';

const EngineerTenderWorkList = () => {
    const navigate = useNavigate();
    const [works, setWorks] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedWorks, setSelectedWorks] = useState([]);
    const [status, setStatus] = useState('');

    // Fetch works (placeholder logic, adjust according to your data structure)
    useEffect(() => {
        const worksRef = dbRef(db, 'ekamwatapzp/WorkNames');
        const unsubscribe = onValue(worksRef, (snapshot) => {
            if (snapshot.exists()) {
                const data = snapshot.val();
                let flattenedWorks = [];
                
                Object.entries(data).forEach(([meetingNum, meetingWorks]) => {
                    Object.entries(meetingWorks).forEach(([id, value]) => {
                        flattenedWorks.push({
                            id,
                            meetingNumber: meetingNum,
                            ...value
                        });
                    });
                });
                
                setWorks(flattenedWorks.reverse()); 
            } else {
                setWorks([]);
            }
            setLoading(false);
        });

        return () => unsubscribe();
    }, []);

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            setSelectedWorks(works.map(w => w.id));
        } else {
            setSelectedWorks([]);
        }
    };

    const handleSelectWork = (id) => {
        if (selectedWorks.includes(id)) {
            setSelectedWorks(selectedWorks.filter(item => item !== id));
        } else {
            setSelectedWorks([...selectedWorks, id]);
        }
    };

    const handleUpdateStatus = () => {
        if (!status) {
            alert("कृपया स्थिती निवडा");
            return;
        }
        if (selectedWorks.length === 0) {
            alert("कृपया काम निवडा");
            return;
        }
        // Add update logic here
        console.log("Updating status:", status, "for works:", selectedWorks);
        alert("स्थिती अपडेट केली!");
    };

    return (
        <EngineerLayout>
            <div className="p-8 bg-[#f4f7fe] min-h-screen">
                {/* Header Section */}
                <div className="flex justify-between items-center mb-10">
                    <div className="flex items-center gap-4">
                        <button 
                            onClick={() => navigate('/engineer/tender-works-menu')}
                            className="p-2 bg-white rounded-full shadow-sm hover:bg-gray-50 transition text-gray-600 border border-gray-100"
                        >
                            <FaArrowLeft size={18} />
                        </button>
                        <h1 className="text-2xl font-bold text-gray-800 tracking-tight text-nowrap">निविदा कामाची यादी पहा</h1>
                    </div>
                    <div className="text-sm font-medium text-gray-400 hidden sm:block">
                        जिल्हा परिषद / <span className="text-gray-500 font-bold">निविदा कामाची यादी पहा</span>
                    </div>
                </div>

                {/* Status Update Form at Top */}
                <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-6 mb-8">
                    <div className="flex flex-col md:flex-row items-end gap-6">
                        <div className="w-full md:w-64">
                            <label className="block text-xs font-bold text-gray-700 mb-2 font-marathi">
                                स्थिती <span className="text-red-500">*</span>
                            </label>
                            <div className="relative">
                                <select 
                                    className="w-full border border-gray-200 rounded-lg px-4 py-2.5 outline-none focus:border-blue-500 text-xs bg-gray-50/50 text-gray-600 appearance-none cursor-pointer font-marathi"
                                    value={status}
                                    onChange={(e) => setStatus(e.target.value)}
                                >
                                    <option value="">स्थिती निवडा</option>
                                    <option value="निविदा प्रक्रिया सुरू">निविदा प्रक्रिया सुरू</option>
                                    <option value="मंजूर">मंजूर</option>
                                    <option value="अपूर्ण">अपूर्ण</option>
                                </select>
                                <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-gray-400">
                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path></svg>
                                </div>
                            </div>
                        </div>
                        <button 
                            onClick={handleUpdateStatus}
                            className="bg-[#4e73df] hover:bg-[#2e59d9] text-white px-8 py-2.5 rounded-lg text-xs font-bold shadow-md shadow-blue-100 transition-all active:scale-95 font-marathi"
                        >
                            स्थिती अपडेट करा
                        </button>
                    </div>
                </div>

                {/* Table Card */}
                <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-0 overflow-hidden mb-8">
                    <div className="overflow-x-auto custom-scrollbar">
                        <table className="w-full border-collapse min-w-[1200px]">
                            <thead>
                                <tr className="border-b border-gray-100">
                                    <th className="px-4 py-4 text-xs font-bold text-gray-800 text-left border-r border-gray-100 w-12">#</th>
                                    <th className="px-4 py-4 text-xs font-bold text-gray-800 text-center border-r border-gray-100 w-16">
                                        <input 
                                            type="checkbox" 
                                            className="w-4 h-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                                            onChange={handleSelectAll}
                                            checked={works.length > 0 && selectedWorks.length === works.length}
                                        />
                                    </th>
                                    <th className="px-4 py-4 text-xs font-bold text-gray-800 text-left border-r border-gray-100">आयडी</th>
                                    <th className="px-4 py-4 text-xs font-bold text-gray-800 text-left border-r border-gray-100">तालुका</th>
                                    <th className="px-4 py-4 text-xs font-bold text-gray-800 text-left border-r border-gray-100">योजनेचे नाव</th>
                                    <th className="px-4 py-4 text-xs font-bold text-gray-800 text-left border-r border-gray-100">निविदा रक्कम</th>
                                    <th className="px-4 py-4 text-xs font-bold text-gray-800 text-left border-r border-gray-100 min-w-[300px]">कामाचे नाव</th>
                                    <th className="px-4 py-4 text-xs font-bold text-gray-800 text-left">काम जोडा</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan="8" className="px-4 py-10 text-center text-gray-400">
                                            <div className="w-8 h-8 border-4 border-blue-600/30 border-t-blue-600 rounded-full animate-spin mx-auto"></div>
                                        </td>
                                    </tr>
                                ) : works.length === 0 ? (
                                    <tr>
                                        <td colSpan="8" className="px-4 py-16 text-center text-gray-600 font-marathi">
                                            कोणतीही माहिती उपलब्ध नाही
                                        </td>
                                    </tr>
                                ) : (
                                    works.map((work, index) => (
                                        <tr key={work.id} className="hover:bg-gray-50/50 transition-colors border-b border-gray-50 last:border-0 text-xs text-gray-600">
                                            <td className="px-4 py-4 border-r border-gray-100">{index + 1}</td>
                                            <td className="px-4 py-4 border-r border-gray-100 text-center">
                                                <input 
                                                    type="checkbox" 
                                                    className="w-4 h-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                                                    checked={selectedWorks.includes(work.id)}
                                                    onChange={() => handleSelectWork(work.id)}
                                                />
                                            </td>
                                            <td className="px-4 py-4 border-r border-gray-100">{work.id}</td>
                                            <td className="px-4 py-4 border-r border-gray-100 font-marathi">{work.taluka || "-"}</td>
                                            <td className="px-4 py-4 border-r border-gray-100 font-marathi">{work.schemeName || "-"}</td>
                                            <td className="px-4 py-4 border-r border-gray-100">{work.tenderAmount || "0"}</td>
                                            <td className="px-4 py-4 border-r border-gray-100 font-marathi italic leading-relaxed">{work.workName || "-"}</td>
                                            <td className="px-4 py-4 text-center">
                                                <button className="text-blue-600 hover:text-blue-800 p-1">
                                                    <FaPlus size={14} />
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Horizontal Scrollbar indicator matching image */}
                <div className="bg-gray-100 h-10 rounded shadow-inner border border-gray-200 flex items-center px-4">
                    <div className="flex-grow bg-gray-400 h-2 rounded-full relative">
                        <div className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-full border-[6px] border-transparent border-r-gray-500 mr-2"></div>
                        <div className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-full border-[6px] border-transparent border-l-gray-500 ml-2"></div>
                    </div>
                </div>
            </div>

            <style>{`
                .custom-scrollbar::-webkit-scrollbar {
                    height: 0px;
                }
                .font-marathi {
                    font-family: 'Hind', sans-serif;
                }
            `}</style>
        </EngineerLayout>
    );
};

export default EngineerTenderWorkList;
